import axios from "../axios"
const context = process.env.VUE_APP_BOOKING_BASE_SERVER_PATH;

// 提交預約
export async function submit(value, mobile = "", token) {
  const { data } = await axios.post(`${context}/public/api/v1/application/dsatSubmit`, value, {
    params: {
      mobile
    },
    headers: {
      token
    },
  })
  return data
}

// dsat-取消預約
export async function cancel(id, token, lang = 'ZH_HANT') {
  const { data } = await axios.get(`${context}/public/api/v1/application/${id}/dsatCancel`, {
    params: {
      lang
    },
    headers: {
      token
    },
  })
  return data
}

// 獲取可預約數-<日期,<時段,可預約數>>
export async function getBookingNum(params, token) {
  const { data } = await axios.get(`${context}/public/api/v1/application/dsat-booking-num`, {
    params,
    headers: {
      token
    },
  })
  return data
}

// 查詢預約--根據手機號，車牌編號，批准編號
export async function getList(params, token) {
  const { data } = await axios.get(`${context}/public/api/v1/application/dsatList`, {
    params,
    headers: {
      token
    },
  })
  return data
}

// 獲取業務信息
// export async function getBusiness(businessCode) {
//   const { data } = await axios.get(`${context}/public/api/v1/application/${businessCode}/business`)
//   return data
// }

// 獲取業務信息列表
export async function getBusinessList() {
  const { data } = await axios.get(`${context}/public/api/v1/application/business/list`)
  return data
}

// dsat-驗證澳方批准信息(登入)
export async function login(params) {
  const { data } = await axios.post(`${context}/public/api/v1/application/login`, null, {
    params
  })
  return data
}
// 登出
export async function logout(token) {
  const { data } = await axios.post(`${context}/public/api/v1/application/logout`, null, {
    headers: {
      token
    },
  })
  return data
}
// dsat-獲取取消次數信息
export async function getCancelInfo(params, token) {
  const { data } = await axios.get(`${context}/public/api/v1/application/getCancelInfo`, {
    params,
    headers: {
      token
    },
  })
  return data
}
// dsat-獲取禁止預約信息
export async function getHitConfig(params, token) {
  const { data } = await axios.get(`${context}/public/api/v1/application/getHitConfig`, {
    params,
    headers: {
      token
    },
  })
  return data
}